import React, { useState, useEffect, ReactNode } from 'react';
import Loading from '../components/utility/Loading';
import { loadingService } from '../services/loading.service';

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = loadingService.subscribe(setLoading);
    return () => unsubscribe();
  }, []);

  return (
    <>
      {children}
      {loading && <Loading />}
    </>
  );
};
